import { RailsCategory } from '~/typings/services/rails/item';

export default function flattenCategories(categories: RailsCategory[]) {
  const cats: RailsCategory[] = [];

  for (let i = 0; i < categories.length; i++) {
    const category = categories[i];
    if (category.children && Object.keys(category.children).length > 0) {
      cats.push(...flattenCategories(category.children));
    } else if (category.relatable) {
      cats.push(category);
    }
  }

  return cats;
}
